// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import {
//   Phone, BadgeCheck, Star, Activity, Send, CheckCheck, Inbox, Eye, MailOpen, ArrowRight, Search, ArrowLeft
// } from "lucide-react";

// // --- Theme Definition ---
// const THEME = {
//   background: "#f8fafc",
//   foreground: "#0f172a",
//   muted: "#f1f5f9",
//   mutedForeground: "#64748b",
//   border: "#e2e8f0",
//   primary: "#6366f1",
//   primaryForeground: "#ffffff",
//   card: "#ffffff",
// };

// const STATUS_BADGE = {
//   sent: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" },
//   delivered: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" },
//   read: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" },
//   received: { backgroundColor: "#f5f3ff", color: "#6d28d9", borderColor: "#ddd6fe" },
// };

// // --- Sub-component: ProgressBar ---
// function ProgressBar({ label, current, max }) {
//   const numericCurrent = Number(current) || 0;
//   const numericMax = typeof max === 'string' ? Number(max.replace(/,/g, '')) : Number(max) || 1;
//   const pct = Math.min(Math.round((numericCurrent / numericMax) * 100), 100);

//   return (
//     <div style={{ marginBottom: "16px" }}>
//       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
//         <span style={{ fontSize: "12px", fontWeight: 500, color: THEME.foreground }}>{label}</span>
//         <span style={{ fontSize: "12px", color: THEME.mutedForeground }}>{numericCurrent.toLocaleString()} / {max.toLocaleString()}</span>
//       </div>
//       <div style={{ height: "6px", backgroundColor: THEME.muted, borderRadius: "9999px", overflow: "hidden" }}>
//         <div
//           style={{
//             height: "100%",
//             backgroundColor: THEME.primary,
//             borderRadius: "9999px",
//             transition: "all 0.3s ease",
//             width: `${pct}%`
//           }}
//         />
//       </div>
//       <p style={{ fontSize: "10px", color: THEME.mutedForeground, marginTop: "4px", margin: "4px 0 0 0" }}>{pct}% used</p>
//     </div>
//   );
// }

// // --- Sub-component: HoverButton ---
// function HoverButton({ onClick, children, baseStyle, hoverStyle }) {
//   const [isHovered, setIsHovered] = useState(false);
//   return (
//     <button
//       onClick={onClick}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       style={{ ...baseStyle, ...(isHovered ? hoverStyle : {}) }}
//     >
//       {typeof children === "function" ? children(isHovered) : children}
//     </button>
//   );
// }

// const MessageAnalytics = () => {
//   // --- All state hooks ---
//   const [apiData, setApiData] = useState(null);
//   const [contactsCount, setContactsCount] = useState(0);
//   const [waId, setWaId] = useState(null);
//   const [templateCount, setTemplateCount] = useState(0);
//   const [webhookData, setWebhookData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [status, setStatus] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');

//   // Hidden views layout tracker state logic
//   const [isLogViewOnly, setIsLogViewOnly] = useState(false);

//   const itemsPerPage = 10;
//   const navigate = useNavigate();
//   const loggedInUser = JSON.parse(sessionStorage.getItem('user'));

//   // --- Hook 1: Fetch user metadata ---
//   useEffect(() => {
//     const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//     if (!loggedUser) return;

//     const emailToUse = loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;
//     if (!emailToUse) return;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(emailToUse)}`)
//       .then((response) => {
//         const userData = response.data;
//         if (userData.wa_id) {
//           setWaId(userData.wa_id);

//           fetch(`https://emedha.com/echatbot/enotifier/qratting.php?wid=${userData.wa_id}`)
//             .then((res) => res.json())
//             .then((data) => {
//               if (data?.data?.length > 0) {
//                 const {
//                   display_phone_number, verified_name, quality_rating, code_verification_status,
//                 } = data.data[0];

//                 setApiData({
//                   phoneNumber: display_phone_number,
//                   displayName: verified_name,
//                   qualityRating: quality_rating,
//                   codeverificationstatus: code_verification_status,
//                 });
//               }
//             });
//         }
//       })
//       .catch((err) => {
//         console.error("Error retrieving user data:", err);
//       });
//   }, []);

//   // --- Hook 2: Contacts Count ---
//   useEffect(() => {
//     const user = JSON.parse(sessionStorage.getItem('user'));
//     if (!user) return;

//     const finalUserId = user.role === "admin" ? user.id : user.role === "member" ? user.userId : null;
//     if (!finalUserId) return;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/api/contacts/user?user_id=${finalUserId}`)
//       .then((response) => {
//         const contacts = response.data.contacts || [];
//         setContactsCount(contacts.length);
//       })
//       .catch((error) => {
//         console.error("Failed to fetch contacts:", error);
//       });
//   }, []);

//   // --- Hook 3: Template Status Counts ---
//   useEffect(() => {
//     if (!waId) return;
//     fetch(`https://emedha.com/echatbot/enotifier/getTemplateStatus.php?wid=${waId}`)
//       .then(res => res.text())
//       .then(text => {
//         const jsonStart = text.indexOf('{');
//         const jsonString = text.substring(jsonStart);
//         const data = JSON.parse(jsonString);
//         if (Array.isArray(data?.data)) {
//           setTemplateCount(data.data.length);
//         }
//       })
//       .catch(err => {
//         console.error("Failed to fetch template data:", err);
//       });
//   }, [waId]);

//   // --- Hook 4: Webhook table fetch ---
//   useEffect(() => {
//     const webhookTable = loggedInUser?.webhook_table;
//     if (!webhookTable) return;
//     axios.post('https://botapi.emedha.in/pages/api/api/webhook-dataprkrv', {
//       webhook_table: webhookTable
//     })
//       .then((response) => {
//         const sortedData = response.data.sort((a, b) =>
//           new Date(b.received_date) - new Date(a.received_date)
//         );
//         setWebhookData(sortedData);
//         setFilteredData(sortedData);
//       })
//       .catch((err) => {
//         console.error('Error fetching data:', err);
//       });
//   }, []);

//   // --- Count Computations ---
//   const sentMessagesCount = webhookData.filter(item => item.status === 'sent').length;
//   const deliveredMessagesCount = webhookData.filter(item => item.status === 'delivered').length;
//   const readMessagesCount = webhookData.filter(item => item.status === 'read').length;
//   const receivedMessagesCount = webhookData.filter(item => item.receivedMessage && item.receivedMessage !== '').length;

//   // --- Handlers ---
//   const filterData = (filterType) => {
//     setStatus(filterType);
//     let filtered = [];
//     if (filterType === 'receivedMessage') {
//       filtered = webhookData.filter(item => item.receivedMessage && item.receivedMessage !== '');
//     } else {
//       filtered = webhookData.filter(item => item.status === filterType || filterType === '');
//     }
//     setFilteredData(filtered);
//     setCurrentPage(1);
//     setIsLogViewOnly(true); // Switches off tracking display cards
//   };

//   const handleBackToDashboard = () => {
//     setIsLogViewOnly(false); // Restores grid cards
//   };

//   const handleMessageClick = (item) => {
//     if (item.waid) {
//       navigate('/MessagePanel/Message-Panel', { state: { contact: item } });
//     } else if (item.receivedMessage) {
//       navigate('/MessagePanel/Message-Panel', { state: { messageData: item } });
//     }
//   };

//   const handleSearch = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     const filtered = webhookData.filter(item =>
//       item.waid?.includes(value) || item.customer_mobile?.includes(value)
//     );
//     setFilteredData(filtered);
//     setCurrentPage(1);
//   };

//   // --- Pagination calculations ---
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
//   const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;

//   const TABS = [
//     { label: "Sent", statusFilter: "sent", icon: <Send size={13} />, 
//     count: sentMessagesCount,
//      color: { color: "#2563eb", backgroundColor: "#eff6ff", borderColor: "#bfdbfe" }, 
//      badge: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" },
//       //     action: () => {
//       //   const receivedData = webhookData.filter(
//       //     item => item.receivedMessage && item.receivedMessage.trim() !== ""
//       //   );

//       //   navigate("SendMessage", {
//       //     state: {
//       //       receivedMessages: receivedData,
//       //     },
//       //   });
//       // }
//      },
//     { label: "Delivered", statusFilter: "delivered", icon: <CheckCheck size={13} />, count: deliveredMessagesCount, color: { color: "#059669", backgroundColor: "#ecfdf5", borderColor: "#a7f3d0" }, badge: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" } },
//     { label: "Read", statusFilter: "read", icon: <Eye size={13} />, count: readMessagesCount, color: { color: "#475569", backgroundColor: "#f1f5f9", borderColor: "#e2e8f0" }, badge: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" } },
//     // { label: "Received Message", statusFilter: "receivedMessage", icon: <MailOpen size={13} />,
//     //  count: receivedMessagesCount, 
//     //  color: { color: "#7c3aed", backgroundColor: "#f5f3ff", borderColor: "#ddd6fe" }, 
//     //  badge: { backgroundColor: "#f5f3ff", color: "#6d28d9", borderColor: "#ddd6fe" },
//     //  action: () => navigate("ReceivedMessages") },
//     // {
//     //   label: "Received Message",
//     //   statusFilter: "receivedMessage",
//     //   icon: <MailOpen size={13} />,
//     //   count: receivedMessagesCount,
//     //   color: { color: "#7c3aed", backgroundColor: "#f5f3ff", borderColor: "#ddd6fe" },
//     //   badge: { backgroundColor: "#f5f3ff", color: "#6d28d9", borderColor: "#ddd6fe" },

//     //   action: () => {
//     //     const receivedData = webhookData.filter(
//     //       item => item.receivedMessage && item.receivedMessage.trim() !== ""
//     //     );

//     //     navigate("ReceivedMessages", {
//     //       state: {
//     //         receivedMessages: receivedData,
//     //       },
//     //     });
//     //   }
//     // }

//   ];

//   return (
//     <div style={{ flex: 1, overflowY: "auto", backgroundColor: THEME.background, fontFamily: "system-ui, -apple-system, sans-serif" }}>

//       {/* Global Responsive Layout Configuration Style Blocks */}
//       <style>{`
//         .desktop-table-view { display: block; }
//         .mobile-cards-view { display: none; }
        
//         @media (max-width: 768px) {
//           .desktop-table-view { display: none !important; }
//           .mobile-cards-view { 
//             display: block !important; 
//             padding: 10px 16px;
//           }
//           .mobile-card-row {
//             background-color: #ffffff;
//             border-bottom: 1px solid ${THEME.border};
//             padding: 16px 0;
//             display: flex;
//             flex-direction: column;
//             gap: 10px;
//           }
//           .mobile-card-row:last-child {
//             border-bottom: none;
//           }
//         }
//       `}</style>



//       <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

//         {/* Hiding remaining dashboards segments if true */}
//         {!isLogViewOnly && (
//           <>



//             {/* Filter Navigation Options Bar */}
//             <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "center" }}>
//               {/* <HoverButton
//                 onClick={() => navigate('/message_analytics/SendMessage')}
//                 baseStyle={{
//                   flex: "1 1 150px", backgroundColor: THEME.primary, borderRadius: "12px", border: `1px solid ${THEME.primary}`,
//                   padding: "14px 16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease-in-out", boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
//                 }}
//                 hoverStyle={{ transform: "translateY(-2px)", boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)" }}
//               >
//                 {(hovered) => (
//                   <>
//                     <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px", width: "100%" }}>
//                       <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(255,255,255,0.2)", color: "#ffffff" }}>
//                         <Send size={13} />
//                       </span>
//                       <ArrowRight size={13} style={{ color: "rgba(255,255,255,0.6)", marginLeft: "auto", transform: hovered ? "translateX(2px)" : "none", transition: "all 0.2s" }} />
//                     </div>
//                     <p style={{ fontSize: "13px", fontWeight: "600", color: "#ffffff", margin: 0 }}>Compose</p>
//                     <p style={{ fontSize: "11px", color: "rgba(255,255,255,0.7)", marginTop: "1px", margin: 0 }}>Send Messaging</p>
//                   </>
//                 )}
//               </HoverButton> */}

//               <HoverButton
//                 onClick={() => filterData('')}
//                 baseStyle={{
//                   flex: "1 1 140px", backgroundColor: status === '' ? "#f8fafc" : THEME.card, borderRadius: "12px", border: status === '' ? `2px solid ${THEME.primary}` : `1px solid ${THEME.border}`,
//                   padding: "14px 16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease"
//                 }}
//                 hoverStyle={{ transform: "translateY(-2px)" }}
//               >
//                 <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
//                   <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f1f5f9", color: THEME.foreground }}>
//                     <Inbox size={13} />
//                   </span>
//                 </div>
//                 <p style={{ fontSize: "13px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>All</p>
//                 <p style={{ fontSize: "11px", color: THEME.mutedForeground, marginTop: "1px", margin: 0 }}>{webhookData.length} total logs</p>
//               </HoverButton>

//               {TABS.map(({ label, statusFilter, icon, count, color, badge, action }) => (
//                 <HoverButton
//                   key={label}
//                   //   onClick={() => filterData(statusFilter)}
//                   onClick={() => action ? action() : filterData(statusFilter)}
//                   baseStyle={{
//                     flex: "1 1 160px", backgroundColor: status === statusFilter ? "#f8fafc" : THEME.card, borderRadius: "12px", border: status === statusFilter ? `2px solid ${THEME.primary}` : `1px solid ${THEME.border}`,
//                     padding: "14px 16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease", boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
//                   }}
//                   hoverStyle={{ transform: "translateY(-2px)" }}
//                 >
//                   <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
//                     <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", border: "1px solid", ...color }}>{icon}</span>
//                   </div>
//                   <p style={{ fontSize: "13px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>{label}</p>
//                   <span style={{ display: "inline-flex", alignItems: "center", marginTop: "4px", padding: "1px 6px", borderRadius: "9999px", fontSize: "10px", fontWeight: "500", border: "1px solid", ...badge }}>
//                     {count} entries
//                   </span>
//                 </HoverButton>
//               ))}
//             </div>
//           </>
//         )}

//         {/* Main Log Data Grid Window */}
//         <div style={{ backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, boxShadow: "0 1px 3px rgba(0,0,0,0.05)", overflow: "hidden" }}>

//           {/* Search Inputs Header Controls */}
//           <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.border}`, display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
//             <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//               {isLogViewOnly && (
//                 <button
//                   onClick={handleBackToDashboard}
//                   style={{
//                     display: "inline-flex", alignItems: "center", gap: "6px", backgroundColor: "transparent",
//                     border: `1px solid ${THEME.border}`, padding: "6px 12px", borderRadius: "6px", cursor: "pointer",
//                     fontSize: "12px", fontWeight: "500", color: THEME.foreground, transition: "background-color 0.2s"
//                   }}
//                   onMouseEnter={(e) => e.currentTarget.style.backgroundColor = THEME.muted}
//                   onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
//                 >
//                   <ArrowLeft size={14} /> Back
//                 </button>
//               )}
//               <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <Inbox size={15} style={{ color: THEME.primary }} />
//                 <h3 style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Webhook Activity Logs</h3>
//               </div>
//             </div>

//             <div style={{ position: "relative", width: "100%", maxWidth: "360px" }}>
//               <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: THEME.mutedForeground, display: "flex", alignItems: "center" }}>
//                 <Search size={14} />
//               </span>
//               <input
//                 type="text"
//                 placeholder="Search by Mobile Number..."
//                 value={searchTerm}
//                 onChange={handleSearch}
//                 style={{
//                   width: "100%", padding: "8px 12px 8px 34px", fontSize: "13px", borderRadius: "8px",
//                   border: `1px solid ${THEME.border}`, outline: "none", color: THEME.foreground, backgroundColor: "#fafafa"
//                 }}
//               />
//             </div>
//           </div>

//           {/* 1. DESKTOP VIEW STANDARD LAYOUT */}
//           <div className="desktop-table-view" style={{ overflowX: "auto", width: "100%" }}>
//             <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", fontSize: "13px" }}>
//               <thead>
//                 <tr style={{ borderBottom: `1px solid ${THEME.border}`, backgroundColor: "rgba(241,245,249,0.5)" }}>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>ID</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Customer Mobile</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Status</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Received Message</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Received Date</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.length > 0 ? (
//                   currentItems.map((item) => (
//                     <tr key={item.id} style={{ borderBottom: `1px solid ${THEME.border}`, transition: "background-color 0.2s" }}>
//                       <td style={{ padding: "14px 20px" }}>
//                         <span style={{ fontFamily: "monospace", fontSize: "12px", color: THEME.mutedForeground }}>{item.id}</span>
//                       </td>
//                       <td style={{ padding: "14px 20px", fontWeight: "500" }}>
//                          <span style={{ fontFamily: "monospace", fontSize: "12px", color: THEME.mutedForeground }}>{item.customer_mobile}</span>
//                         {/* {item.waid ? (
//                           <span style={{ color: "#059669", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.waid}</span>
//                         ) : (
//                           <span style={{ color: "#2563eb", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.customer_mobile}</span>
//                         )} */}
//                       </td>
//                       <td style={{ padding: "14px 20px" }}>
//                         <span style={{
//                           display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: "500",
//                           textTransform: "capitalize", border: "1px solid", ...(STATUS_BADGE[item.status] || STATUS_BADGE.read)
//                         }}>
//                           {item.status || "Unknown"}
//                         </span>
//                       </td>
//                       <td
//                         onClick={() => handleMessageClick(item)}
//                         style={{ padding: "14px 20px", maxWidth: "260px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", cursor: 'pointer', color: '#2563eb' }}
//                       >
//                         {item.receivedMessage || <span style={{ color: THEME.mutedForeground }}>—</span>}
//                       </td>
//                       <td style={{ padding: "14px 20px", color: THEME.mutedForeground, whiteSpace: "nowrap" }}>
//                         {item.received_date ? new Date(item.received_date).toLocaleDateString() : "—"}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={5} style={{ padding: "32px", textAlign: "center", color: THEME.mutedForeground }}>No logs matching selected conditions.</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* 2. MOBILE VIEW: RENDERS STACKED VERTICALLY ONE AFTER ANOTHER */}
//           <div className="mobile-cards-view">
//             {currentItems.length > 0 ? (
//               currentItems.map((item) => (
//                 <div key={item.id} className="mobile-card-row">
//                   {/* Row 1: ID & Status Badge stacked side by side inside the block line item */}
//                   <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                     <span style={{ fontSize: "12px", fontFamily: "monospace", color: THEME.mutedForeground }}>#{item.id}</span>
//                     <span style={{
//                       display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: "500",
//                       textTransform: "capitalize", border: "1px solid", ...(STATUS_BADGE[item.status] || STATUS_BADGE.read)
//                     }}>
//                       {item.status || "Unknown"}
//                     </span>
//                   </div>

//                   {/* Row 2: Customer Contact Number Label followed by actual Number */}
//                   <div>
//                     <div style={{ fontSize: "11px", color: THEME.mutedForeground, textTransform: "uppercase", fontWeight: "600", marginBottom: "2px" }}>Customer Mobile</div>
//                     <div style={{ fontSize: "14px", fontWeight: "500" }}>
//                       {item.waid ? (
//                         <span style={{ color: "#059669", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.waid}</span>
//                       ) : (
//                         <span style={{ color: "#2563eb", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.customer_mobile}</span>
//                       )}
//                     </div>
//                   </div>

//                   {/* Row 3: Message Text block description section */}
//                   <div>
//                     <div style={{ fontSize: "11px", color: THEME.mutedForeground, textTransform: "uppercase", fontWeight: "600", marginBottom: "2px" }}>Received Message</div>
//                     <div
//                       onClick={() => handleMessageClick(item)}
//                       style={{ fontSize: "13px", color: '#2563eb', cursor: 'pointer', wordBreak: "break-word" }}
//                     >
//                       {item.receivedMessage || <span style={{ color: THEME.mutedForeground }}>—</span>}
//                     </div>
//                   </div>

//                   {/* Row 4: Timeline Entry Date */}
//                   <div>
//                     <div style={{ fontSize: "11px", color: THEME.mutedForeground, textTransform: "uppercase", fontWeight: "600", marginBottom: "2px" }}>Received Date</div>
//                     <div style={{ fontSize: "13px", color: THEME.foreground }}>
//                       {item.received_date ? new Date(item.received_date).toLocaleDateString() : "—"}
//                     </div>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div style={{ padding: "32px", textAlign: "center", color: THEME.mutedForeground, fontSize: "13px" }}>
//                 No logs matching selected conditions.
//               </div>
//             )}
//           </div>

//           {/* Table Pagination Actions block panel */}
//           <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderTop: `1px solid ${THEME.border}`, backgroundColor: "#fafafa" }}>
//             <p style={{ fontSize: "12px", color: THEME.mutedForeground, margin: 0 }}>
//               Showing {filteredData.length > 0 ? indexOfFirstItem + 1 : 0} to {Math.min(indexOfLastItem, filteredData.length)} of {filteredData.length} entries
//             </p>
//             <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//               <button
//                 onClick={() => paginate(currentPage - 1)}
//                 disabled={currentPage === 1}
//                 style={{
//                   padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: currentPage === 1 ? "#94a3b8" : THEME.foreground,
//                   border: `1px solid ${THEME.border}`, backgroundColor: THEME.card, cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
//                 }}
//               >
//                 Previous
//               </button>
//               <span style={{ fontSize: "12px", fontWeight: "600", padding: "0 8px", color: THEME.foreground }}>
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button
//                 onClick={() => paginate(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//                 style={{
//                   padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: currentPage === totalPages ? "#94a3b8" : THEME.foreground,
//                   border: `1px solid ${THEME.border}`, backgroundColor: THEME.card, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
//                 }}
//               >
//                 Next
//               </button>
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default MessageAnalytics;




























// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import {
//   Phone, BadgeCheck, Star, Activity, Send, CheckCheck, Inbox, Eye, ArrowRight, Search, ArrowLeft
// } from "lucide-react";

// // --- Theme Definition ---
// const THEME = {
//   background: "#f8fafc",
//   foreground: "#0f172a",
//   muted: "#f1f5f9",
//   mutedForeground: "#64748b",
//   border: "#e2e8f0",
//   primary: "#6366f1",
//   primaryForeground: "#ffffff",
//   card: "#ffffff",
// };

// const STATUS_BADGE = {
//   sent: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" },
//   delivered: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" },
//   read: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" },
//   failed: { backgroundColor: "#fdf2f2", color: "#b91c1c", borderColor: "#fde8e8" },
//   failure: { backgroundColor: "#fdf2f2", color: "#b91c1c", borderColor: "#fde8e8" }
// };

// // --- Sub-component: ProgressBar ---
// function ProgressBar({ label, current, max }) {
//   const numericCurrent = Number(current) || 0;
//   const numericMax = typeof max === 'string' ? Number(max.replace(/,/g, '')) : Number(max) || 1;
//   const pct = Math.min(Math.round((numericCurrent / numericMax) * 100), 100);

//   return (
//     <div style={{ marginBottom: "16px" }}>
//       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
//         <span style={{ fontSize: "12px", fontWeight: 500, color: THEME.foreground }}>{label}</span>
//         <span style={{ fontSize: "12px", color: THEME.mutedForeground }}>{numericCurrent.toLocaleString()} / {max.toLocaleString()}</span>
//       </div>
//       <div style={{ height: "6px", backgroundColor: THEME.muted, borderRadius: "9999px", overflow: "hidden" }}>
//         <div
//           style={{
//             height: "100%",
//             backgroundColor: THEME.primary,
//             borderRadius: "9999px",
//             transition: "all 0.3s ease",
//             width: `${pct}%`
//           }}
//         />
//       </div>
//       <p style={{ fontSize: "10px", color: THEME.mutedForeground, marginTop: "4px", margin: "4px 0 0 0" }}>{pct}% used</p>
//     </div>
//   );
// }

// // --- Sub-component: HoverButton ---
// function HoverButton({ onClick, children, baseStyle, hoverStyle }) {
//   const [isHovered, setIsHovered] = useState(false);
//   return (
//     <button
//       onClick={onClick}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       style={{ ...baseStyle, ...(isHovered ? hoverStyle : {}) }}
//     >
//       {typeof children === "function" ? children(isHovered) : children}
//     </button>
//   );
// }

// const MessageAnalytics = () => {
//   // --- All state hooks ---
//   const [apiData, setApiData] = useState(null);
//   const [contactsCount, setContactsCount] = useState(0);
//   const [waId, setWaId] = useState(null);
//   const [templateCount, setTemplateCount] = useState(0);
//   const [webhookData, setWebhookData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [status, setStatus] = useState('sent'); // Start defaulted to 'sent' state since All is removed
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');

//   // Hidden views layout tracker state logic
//   const [isLogViewOnly, setIsLogViewOnly] = useState(false);

//   const itemsPerPage = 10;
//   const navigate = useNavigate();
//   const loggedInUser = JSON.parse(sessionStorage.getItem('user'));

//   // --- Hook 1: Fetch user metadata ---
//   useEffect(() => {
//     const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//     if (!loggedUser) return;

//     const emailToUse = loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;
//     if (!emailToUse) return;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(emailToUse)}`)
//       .then((response) => {
//         const userData = response.data;
//         if (userData.wa_id) {
//           setWaId(userData.wa_id);

//           fetch(`https://emedha.com/echatbot/enotifier/qratting.php?wid=${userData.wa_id}`)
//             .then((res) => res.json())
//             .then((data) => {
//               if (data?.data?.length > 0) {
//                 const {
//                   display_phone_number, verified_name, quality_rating, code_verification_status,
//                 } = data.data[0];

//                 setApiData({
//                   phoneNumber: display_phone_number,
//                   displayName: verified_name,
//                   qualityRating: quality_rating,
//                   codeverificationstatus: code_verification_status,
//                 });
//               }
//             });
//         }
//       })
//       .catch((err) => {
//         console.error("Error retrieving user data:", err);
//       });
//   }, []);

//   // --- Hook 2: Contacts Count ---
//   useEffect(() => {
//     const user = JSON.parse(sessionStorage.getItem('user'));
//     if (!user) return;

//     const finalUserId = user.role === "admin" ? user.id : user.role === "member" ? user.userId : null;
//     if (!finalUserId) return;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/api/contacts/user?user_id=${finalUserId}`)
//       .then((response) => {
//         const contacts = response.data.contacts || [];
//         setContactsCount(contacts.length);
//       })
//       .catch((error) => {
//         console.error("Failed to fetch contacts:", error);
//       });
//   }, []);

//   // --- Hook 3: Template Status Counts ---
//   useEffect(() => {
//     if (!waId) return;
//     fetch(`https://emedha.com/echatbot/enotifier/getTemplateStatus.php?wid=${waId}`)
//       .then(res => res.text())
//       .then(text => {
//         const jsonStart = text.indexOf('{');
//         const jsonString = text.substring(jsonStart);
//         const data = JSON.parse(jsonString);
//         if (Array.isArray(data?.data)) {
//           setTemplateCount(data.data.length);
//         }
//       })
//       .catch(err => {
//         console.error("Failed to fetch template data:", err);
//       });
//   }, [waId]);

//   // --- Hook 4: Webhook table fetch ---
//   useEffect(() => {
//     const webhookTable = loggedInUser?.webhook_table;
//     if (!webhookTable) return;
//     axios.post('https://botapi.emedha.in/pages/api/api/webhook-dataprkrv', {
//       webhook_table: webhookTable
//     })
//       .then((response) => {
//         const sortedData = response.data.sort((a, b) =>
//           new Date(b.received_date) - new Date(a.received_date)
//         );
//         setWebhookData(sortedData);
//         // Default initial view to "sent" matching initial state status
//         const initialSent = sortedData.filter(item => item.status === 'sent');
//         setFilteredData(initialSent);
//       })
//       .catch((err) => {
//         console.error('Error fetching data:', err);
//       });
//   }, []);

//   // --- Count Computations ---
//   const sentMessagesCount = webhookData.filter(item => item.status === 'sent').length;
//   const deliveredMessagesCount = webhookData.filter(item => item.status === 'delivered').length;
//   const readMessagesCount = webhookData.filter(item => item.status === 'read').length;
//   const failureMessagesCount = webhookData.filter(item => item.status === 'failed' || item.status === 'failure').length;

//   // --- Handlers ---
//   const filterData = (filterType) => {
//     setStatus(filterType);
//     let filtered = [];
//     if (filterType === 'failed' || filterType === 'failure') {
//       filtered = webhookData.filter(item => item.status === 'failed' || item.status === 'failure');
//     } else {
//       filtered = webhookData.filter(item => item.status === filterType);
//     }
//     setFilteredData(filtered);
//     setCurrentPage(1);
//     setIsLogViewOnly(true); 
//   };

//   const handleBackToDashboard = () => {
//     setIsLogViewOnly(false); 
//   };

//   const handleMessageClick = (item) => {
//     if (item.waid) {
//       navigate('/MessagePanel/Message-Panel', { state: { contact: item } });
//     } else if (item.receivedMessage) {
//       navigate('/MessagePanel/Message-Panel', { state: { messageData: item } });
//     }
//   };

//   const handleSearch = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     const activeBase = status === 'failure' || status === 'failed' 
//       ? webhookData.filter(item => item.status === 'failed' || item.status === 'failure')
//       : webhookData.filter(item => item.status === status);

//     const filtered = activeBase.filter(item =>
//       item.waid?.includes(value) || item.customer_mobile?.includes(value)
//     );
//     setFilteredData(filtered);
//     setCurrentPage(1);
//   };

//   // --- Pagination calculations ---
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
//   const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;

//   const TABS = [
//     { 
//       label: "Sent", 
//       statusFilter: "sent", 
//       icon: <Send size={13} />, 
//       count: sentMessagesCount,
//       color: { color: "#2563eb", backgroundColor: "#eff6ff", borderColor: "#bfdbfe" }, 
//       badge: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" }
//     },
//     { 
//       label: "Delivered", 
//       statusFilter: "delivered", 
//       icon: <CheckCheck size={13} />, 
//       count: deliveredMessagesCount, 
//       color: { color: "#059669", backgroundColor: "#ecfdf5", borderColor: "#a7f3d0" }, 
//       badge: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" } 
//     },
//     { 
//       label: "Read", 
//       statusFilter: "read", 
//       icon: <Eye size={13} />, 
//       count: readMessagesCount, 
//       color: { color: "#475569", backgroundColor: "#f1f5f9", borderColor: "#e2e8f0" }, 
//       badge: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" } 
//     },
//     { 
//       label: "Failure", 
//       statusFilter: "failure", 
//       icon: <Activity size={13} />, 
//       count: failureMessagesCount, 
//       color: { color: "#b91c1c", backgroundColor: "#fdf2f2", borderColor: "#fde8e8" }, 
//       badge: { backgroundColor: "#fdf2f2", color: "#b91c1c", borderColor: "#fde8e8" } 
//     }
//   ];

//   return (
//     <div style={{ flex: 1, overflowY: "auto", backgroundColor: THEME.background, fontFamily: "system-ui, -apple-system, sans-serif" }}>

//       <style>{`
//         .desktop-table-view { display: block; }
//         .mobile-cards-view { display: none; }
        
//         @media (max-width: 768px) {
//           .desktop-table-view { display: none !important; }
//           .mobile-cards-view { 
//             display: block !important; 
//             padding: 10px 16px;
//           }
//           .mobile-card-row {
//             background-color: #ffffff;
//             border-bottom: 1px solid ${THEME.border};
//             padding: 16px 0;
//             display: flex;
//             flex-direction: column;
//             gap: 10px;
//           }
//           .mobile-card-row:last-child {
//             border-bottom: none;
//           }
//         }
//       `}</style>

//       <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

//         {!isLogViewOnly && (
//           <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "center" }}>
//             {TABS.map(({ label, statusFilter, icon, count, color, badge, action }) => (
//               <HoverButton
//                 key={label}
//                 onClick={() => action ? action() : filterData(statusFilter)}
//                 baseStyle={{
//                   flex: "1 1 160px", backgroundColor: status === statusFilter ? "#f8fafc" : THEME.card, borderRadius: "12px", border: status === statusFilter ? `2px solid ${THEME.primary}` : `1px solid ${THEME.border}`,
//                   padding: "14px 16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease", boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
//                 }}
//                 hoverStyle={{ transform: "translateY(-2px)" }}
//               >
//                 <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
//                   <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", border: "1px solid", ...color }}>{icon}</span>
//                 </div>
//                 <p style={{ fontSize: "13px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>{label}</p>
//                 <span style={{ display: "inline-flex", alignItems: "center", marginTop: "4px", padding: "1px 6px", borderRadius: "9999px", fontSize: "10px", fontWeight: "500", border: "1px solid", ...badge }}>
//                   {count} entries
//                 </span>
//               </HoverButton>
//             ))}
//           </div>
//         )}

//         {/* Main Log Data Grid Window */}
//         <div style={{ backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, boxShadow: "0 1px 3px rgba(0,0,0,0.05)", overflow: "hidden" }}>

//           {/* Search Inputs Header Controls */}
//           <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.border}`, display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
//             <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//               {isLogViewOnly && (
//                 <button
//                   onClick={handleBackToDashboard}
//                   style={{
//                     display: "inline-flex", alignItems: "center", gap: "6px", backgroundColor: "transparent",
//                     border: `1px solid ${THEME.border}`, padding: "6px 12px", borderRadius: "6px", cursor: "pointer",
//                     fontSize: "12px", fontWeight: "500", color: THEME.foreground, transition: "background-color 0.2s"
//                   }}
//                   onMouseEnter={(e) => e.currentTarget.style.backgroundColor = THEME.muted}
//                   onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
//                 >
//                   <ArrowLeft size={14} /> Back
//                 </button>
//               )}
//               <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <Inbox size={15} style={{ color: THEME.primary }} />
//                 {/* <h3 style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}></h3> */}
//               </div>
//             </div>

//             <div style={{ position: "relative", width: "100%", maxWidth: "360px" }}>
//               <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: THEME.mutedForeground, display: "flex", alignItems: "center" }}>
//                 <Search size={14} />
//               </span>
//               <input
//                 type="text"
//                 placeholder="Search within active tab..."
//                 value={searchTerm}
//                 onChange={handleSearch}
//                 style={{
//                   width: "100%", padding: "8px 12px 8px 34px", fontSize: "13px", borderRadius: "8px",
//                   border: `1px solid ${THEME.border}`, outline: "none", color: THEME.foreground, backgroundColor: "#fafafa"
//                 }}
//               />
//             </div>
//           </div>

//           {/* 1. DESKTOP VIEW STANDARD LAYOUT */}
//           <div className="desktop-table-view" style={{ overflowX: "auto", width: "100%" }}>
//             <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", fontSize: "13px" }}>
//               <thead>
//                 <tr style={{ borderBottom: `1px solid ${THEME.border}`, backgroundColor: "rgba(241,245,249,0.5)" }}>
//                    <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Customer Mobile</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Status</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Date</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.length > 0 ? (
//                   currentItems.map((item) => (
//                     <tr key={item.id} style={{ borderBottom: `1px solid ${THEME.border}`, transition: "background-color 0.2s" }}>
                      
//                       <td style={{ padding: "14px 20px", fontWeight: "500" }}>
//                          <span style={{ fontFamily: "monospace", fontSize: "12px", color: THEME.mutedForeground }}>{item.customer_mobile}</span>
//                       </td>
//                       <td style={{ padding: "14px 20px" }}>
//                         <span style={{
//                           display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: "500",
//                           textTransform: "capitalize", border: "1px solid", ...(STATUS_BADGE[item.status] || STATUS_BADGE.read)
//                         }}>
//                           {item.status || "Unknown"}
//                         </span>
//                       </td>
//                         <td style={{ padding: "14px 20px", color: THEME.mutedForeground, whiteSpace: "nowrap" }}>
//                         {item.received_date ? new Date(item.received_date).toLocaleDateString() : "—"}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={5} style={{ padding: "32px", textAlign: "center", color: THEME.mutedForeground }}>No logs matching selected conditions.</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* 2. MOBILE VIEW */}
//           <div className="mobile-cards-view">
//             {currentItems.length > 0 ? (
//               currentItems.map((item) => (
//                 <div key={item.id} className="mobile-card-row">
//                   <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                     <span style={{ fontSize: "12px", fontFamily: "monospace", color: THEME.mutedForeground }}>#{item.id}</span>
//                     <span style={{
//                       display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: "500",
//                       textTransform: "capitalize", border: "1px solid", ...(STATUS_BADGE[item.status] || STATUS_BADGE.read)
//                         }}>
//                       {item.status || "Unknown"}
//                     </span>
//                   </div>

//                   <div>
//                     <div style={{ fontSize: "11px", color: THEME.mutedForeground, textTransform: "uppercase", fontWeight: "600", marginBottom: "2px" }}>Customer Mobile</div>
//                     <div style={{ fontSize: "14px", fontWeight: "500" }}>
//                       {item.waid ? (
//                         <span style={{ color: "#059669", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.waid}</span>
//                       ) : (
//                         <span style={{ color: "#2563eb", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.customer_mobile}</span>
//                       )}
//                     </div>
//                   </div>

//                   <div>
//                     <div style={{ fontSize: "11px", color: THEME.mutedForeground, textTransform: "uppercase", fontWeight: "600", marginBottom: "2px" }}>Received Message</div>
//                     <div
//                       onClick={() => handleMessageClick(item)}
//                       style={{ fontSize: "13px", color: '#2563eb', cursor: 'pointer', wordBreak: "break-word" }}
//                     >
//                       {item.receivedMessage || <span style={{ color: THEME.mutedForeground }}>—</span>}
//                     </div>
//                   </div>

//                   <div>
//                     <div style={{ fontSize: "11px", color: THEME.mutedForeground, textTransform: "uppercase", fontWeight: "600", marginBottom: "2px" }}>Received Date</div>
//                     <div style={{ fontSize: "13px", color: THEME.foreground }}>
//                       {item.received_date ? new Date(item.received_date).toLocaleDateString() : "—"}
//                     </div>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div style={{ padding: "32px", textAlign: "center", color: THEME.mutedForeground, fontSize: "13px" }}>
//                 No logs matching selected conditions.
//               </div>
//             )}
//           </div>

//           {/* Table Pagination Actions */}
//           <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderTop: `1px solid ${THEME.border}`, backgroundColor: "#fafafa" }}>
//             <p style={{ fontSize: "12px", color: THEME.mutedForeground, margin: 0 }}>
//               Showing {filteredData.length > 0 ? indexOfFirstItem + 1 : 0} to {Math.min(indexOfLastItem, filteredData.length)} of {filteredData.length} entries
//             </p>
//             <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//               <button
//                 onClick={() => paginate(currentPage - 1)}
//                 disabled={currentPage === 1}
//                 style={{
//                   padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: currentPage === 1 ? "#94a3b8" : THEME.foreground,
//                   border: `1px solid ${THEME.border}`, backgroundColor: THEME.card, cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
//                 }}
//               >
//                 Previous
//               </button>
//               <span style={{ fontSize: "12px", fontWeight: "600", padding: "0 8px", color: THEME.foreground }}>
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button
//                 onClick={() => paginate(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//                 style={{
//                   padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: currentPage === totalPages ? "#94a3b8" : THEME.foreground,
//                   border: `1px solid ${THEME.border}`, backgroundColor: THEME.card, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
//                 }}
//               >
//                 Next
//               </button>
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default MessageAnalytics;









import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  Phone, BadgeCheck, Star, Activity, Send, CheckCheck, Inbox, Eye, ArrowRight, Search, ArrowLeft
} from "lucide-react";

// --- Theme Definition ---
const THEME = {
  background: "#f8fafc",
  foreground: "#0f172a",
  muted: "#f1f5f9",
  mutedForeground: "#64748b",
  border: "#e2e8f0",
  primary: "#6366f1",
  primaryForeground: "#ffffff",
  card: "#ffffff",
};

const STATUS_BADGE = {
  sent: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" },
  delivered: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" },
  read: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" },
  failed: { backgroundColor: "#fdf2f2", color: "#b91c1c", borderColor: "#fde8e8" },
  failure: { backgroundColor: "#fdf2f2", color: "#b91c1c", borderColor: "#fde8e8" }
};

// --- Sub-component: ProgressBar ---
function ProgressBar({ label, current, max }) {
  const numericCurrent = Number(current) || 0;
  const numericMax = typeof max === 'string' ? Number(max.replace(/,/g, '')) : Number(max) || 1;
  const pct = Math.min(Math.round((numericCurrent / numericMax) * 100), 100);

  return (
    <div style={{ marginBottom: "16px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
        <span style={{ fontSize: "12px", fontWeight: 500, color: THEME.foreground }}>{label}</span>
        <span style={{ fontSize: "12px", color: THEME.mutedForeground }}>{numericCurrent.toLocaleString()} / {max.toLocaleString()}</span>
      </div>
      <div style={{ height: "6px", backgroundColor: THEME.muted, borderRadius: "9999px", overflow: "hidden" }}>
        <div
          style={{
            height: "100%",
            backgroundColor: THEME.primary,
            borderRadius: "9999px",
            transition: "all 0.3s ease",
            width: `${pct}%`
          }}
        />
      </div>
      <p style={{ fontSize: "10px", color: THEME.mutedForeground, marginTop: "4px", margin: "4px 0 0 0" }}>{pct}% used</p>
    </div>
  );
}

// --- Sub-component: HoverButton ---
function HoverButton({ onClick, children, baseStyle, hoverStyle }) {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ ...baseStyle, ...(isHovered ? hoverStyle : {}) }}
    >
      {typeof children === "function" ? children(isHovered) : children}
    </button>
  );
}

const MessageAnalytics = () => {
  // --- All state hooks ---
  const [apiData, setApiData] = useState(null);
  const [contactsCount, setContactsCount] = useState(0);
  const [waId, setWaId] = useState(null);
  const [templateCount, setTemplateCount] = useState(0);
  const [webhookData, setWebhookData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [status, setStatus] = useState('sent'); 
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');

  // --- Date Filter State Targets ---
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // Hidden views layout tracker state logic
  const [isLogViewOnly, setIsLogViewOnly] = useState(false);

  const itemsPerPage = 10;
  const navigate = useNavigate();
  const loggedInUser = JSON.parse(sessionStorage.getItem('user'));

  // --- Hook 1: Fetch user metadata ---
  useEffect(() => {
    const loggedUser = JSON.parse(sessionStorage.getItem("user"));
    if (!loggedUser) return;

    const emailToUse = loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;
    if (!emailToUse) return;

    axios
      .get(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(emailToUse)}`)
      .then((response) => {
        const userData = response.data;
        if (userData.wa_id) {
          setWaId(userData.wa_id);

          fetch(`https://emedha.com/echatbot/enotifier/qratting.php?wid=${userData.wa_id}`)
            .then((res) => res.json())
            .then((data) => {
              if (data?.data?.length > 0) {
                const {
                  display_phone_number, verified_name, quality_rating, code_verification_status,
                } = data.data[0];

                setApiData({
                  phoneNumber: display_phone_number,
                  displayName: verified_name,
                  qualityRating: quality_rating,
                  codeverificationstatus: code_verification_status,
                });
              }
            });
        }
      })
      .catch((err) => {
        console.error("Error retrieving user data:", err);
      });
  }, []);

  // --- Hook 2: Contacts Count ---
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (!user) return;

    const finalUserId = user.role === "admin" ? user.id : user.role === "member" ? user.userId : null;
    if (!finalUserId) return;

    axios
      .get(`https://botapi.emedha.in/pages/api/api/contacts/user?user_id=${finalUserId}`)
      .then((response) => {
        const contacts = response.data.contacts || [];
        setContactsCount(contacts.length);
      })
      .catch((error) => {
        console.error("Failed to fetch contacts:", error);
      });
  }, []);

  // --- Hook 3: Template Status Counts ---
  useEffect(() => {
    if (!waId) return;
    fetch(`https://emedha.com/echatbot/enotifier/getTemplateStatus.php?wid=${waId}`)
      .then(res => res.text())
      .then(text => {
        const jsonStart = text.indexOf('{');
        const jsonString = text.substring(jsonStart);
        const data = JSON.parse(jsonString);
        if (Array.isArray(data?.data)) {
          setTemplateCount(data.data.length);
        }
      })
      .catch(err => {
        console.error("Failed to fetch template data:", err);
      });
  }, [waId]);

  // --- Hook 4: Webhook table fetch ---
  useEffect(() => {
    const webhookTable = loggedInUser?.webhook_table;
    if (!webhookTable) return;
    axios.post('https://botapi.emedha.in/pages/api/api/webhook-dataprkrv', {
      webhook_table: webhookTable
    })
      .then((response) => {
        const sortedData = response.data.sort((a, b) =>
          new Date(b.received_date) - new Date(a.received_date)
        );
        setWebhookData(sortedData);
        
        // Match standard structural initial setup triggers
        const initialSent = sortedData.filter(item => item.status === 'sent');
        setFilteredData(initialSent);
      })
      .catch((err) => {
        console.error('Error fetching data:', err);
      });
  }, []);

  // --- Master Multi-Filter Processor ---
  // Processes: Tab Status Selection -> Date Bounds -> Search Queries dynamically
  useEffect(() => {
    let result = [...webhookData];

    // 1. Status Tab filter
    if (status === 'failed' || status === 'failure') {
      result = result.filter(item => item.status === 'failed' || item.status === 'failure');
    } else {
      result = result.filter(item => item.status === status);
    }

    // 2. Date-to-Date ranges parsing
    if (startDate) {
      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);
      result = result.filter(item => {
        if (!item.received_date) return false;
        const itemDate = new Date(item.received_date);
        return itemDate >= start;
      });
    }

    if (endDate) {
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);
      result = result.filter(item => {
        if (!item.received_date) return false;
        const itemDate = new Date(item.received_date);
        return itemDate <= end;
      });
    }

    // 3. Text query input filter
    if (searchTerm.trim() !== '') {
      result = result.filter(item =>
        item.waid?.includes(searchTerm) || item.customer_mobile?.includes(searchTerm)
      );
    }

    setFilteredData(result);
    setCurrentPage(1);
  }, [status, startDate, endDate, searchTerm, webhookData]);

  // --- Count Computations ---
  const sentMessagesCount = webhookData.filter(item => item.status === 'sent').length;
  const deliveredMessagesCount = webhookData.filter(item => item.status === 'delivered').length;
  const readMessagesCount = webhookData.filter(item => item.status === 'read').length;
  const failureMessagesCount = webhookData.filter(item => item.status === 'failed' || item.status === 'failure').length;

  // --- Handlers ---
  const filterData = (filterType) => {
    setStatus(filterType);
    setIsLogViewOnly(true); 
  };

  const handleBackToDashboard = () => {
    setIsLogViewOnly(false); 
  };

  const handleMessageClick = (item) => {
    if (item.waid) {
      navigate('/MessagePanel/Message-Panel', { state: { contact: item } });
    } else if (item.receivedMessage) {
      navigate('/MessagePanel/Message-Panel', { state: { messageData: item } });
    }
  };

  // Safe reset utility button function 
  const handleClearDateFilters = () => {
    setStartDate('');
    setEndDate('');
  };

  // --- Pagination calculations ---
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;

  const TABS = [
    { 
      label: "Sent", 
      statusFilter: "sent", 
      icon: <Send size={13} />, 
      count: sentMessagesCount,
      color: { color: "#2563eb", backgroundColor: "#eff6ff", borderColor: "#bfdbfe" }, 
      badge: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" }
    },
    { 
      label: "Delivered", 
      statusFilter: "delivered", 
      icon: <CheckCheck size={13} />, 
      count: deliveredMessagesCount, 
      color: { color: "#059669", backgroundColor: "#ecfdf5", borderColor: "#a7f3d0" }, 
      badge: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" } 
    },
    { 
      label: "Read", 
      statusFilter: "read", 
      icon: <Eye size={13} />, 
      count: readMessagesCount, 
      color: { color: "#475569", backgroundColor: "#f1f5f9", borderColor: "#e2e8f0" }, 
      badge: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" } 
    },
    // { 
    //   label: "Failure", 
    //   statusFilter: "failure", 
    //   icon: <Activity size={13} />, 
    //   count: failureMessagesCount, 
    //   color: { color: "#b91c1c", backgroundColor: "#fdf2f2", borderColor: "#fde8e8" }, 
    //   badge: { backgroundColor: "#fdf2f2", color: "#b91c1c", borderColor: "#fde8e8" } 
    // }
  ];

  return (
    <div style={{ flex: 1, overflowY: "auto", backgroundColor: THEME.background, fontFamily: "system-ui, -apple-system, sans-serif" }}>

      <style>{`
        .desktop-table-view { display: block; }
        .mobile-cards-view { display: none; }
        
        @media (max-width: 768px) {
          .desktop-table-view { display: none !important; }
          .mobile-cards-view { 
            display: block !important; 
            padding: 10px 16px;
          }
          .mobile-card-row {
            background-color: #ffffff;
            border-bottom: 1px solid ${THEME.border};
            padding: 16px 0;
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          .mobile-card-row:last-child {
            border-bottom: none;
          }
        }
      `}</style>

      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

        {!isLogViewOnly && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "center" }}>
            {TABS.map(({ label, statusFilter, icon, count, color, badge, action }) => (
              <HoverButton
                key={label}
                onClick={() => action ? action() : filterData(statusFilter)}
                baseStyle={{
                  flex: "1 1 160px", backgroundColor: status === statusFilter ? "#f8fafc" : THEME.card, borderRadius: "12px", border: status === statusFilter ? `2px solid ${THEME.primary}` : `1px solid ${THEME.border}`,
                  padding: "14px 16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease", boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
                }}
                hoverStyle={{ transform: "translateY(-2px)" }}
              >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                  <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", border: "1px solid", ...color }}>{icon}</span>
                </div>
                <p style={{ fontSize: "13px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>{label}</p>
                <span style={{ display: "inline-flex", alignItems: "center", marginTop: "4px", padding: "1px 6px", borderRadius: "9999px", fontSize: "10px", fontWeight: "500", border: "1px solid", ...badge }}>
                  {count} entries
                </span>
              </HoverButton>
            ))}
          </div>
        )}

        {/* Main Log Data Grid Window */}
        <div style={{ backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, boxShadow: "0 1px 3px rgba(0,0,0,0.05)", overflow: "hidden" }}>

          {/* Search Inputs Header Controls */}
          <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.border}`, display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "16px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
              {isLogViewOnly && (
                <button
                  onClick={handleBackToDashboard}
                  style={{
                    display: "inline-flex", alignItems: "center", gap: "6px", backgroundColor: "transparent",
                    border: `1px solid ${THEME.border}`, padding: "6px 12px", borderRadius: "6px", cursor: "pointer",
                    fontSize: "12px", fontWeight: "500", color: THEME.foreground, transition: "background-color 0.2s"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = THEME.muted}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                >
                  <ArrowLeft size={14} /> Back
                </button>
              )}
              
              {/* --- NEW DATE TO DATE FILTER SECTION --- */}
              <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  <span style={{ fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>From:</span>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    style={{
                      padding: "5px 8px", fontSize: "12px", borderRadius: "6px", border: `1px solid ${THEME.border}`,
                      outline: "none", color: THEME.foreground, backgroundColor: "#fafafa"
                    }}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  <span style={{ fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>To:</span>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    style={{
                      padding: "5px 8px", fontSize: "12px", borderRadius: "6px", border: `1px solid ${THEME.border}`,
                      outline: "none", color: THEME.foreground, backgroundColor: "#fafafa"
                    }}
                  />
                </div>
                {(startDate || endDate) && (
                  <button
                    onClick={handleClearDateFilters}
                    style={{
                      padding: "5px 10px", fontSize: "11px", fontWeight: "500", borderRadius: "6px",
                      border: "1px solid #fca5a5", backgroundColor: "#fef2f2", color: "#ef4444", cursor: "pointer"
                    }}
                  >
                    Clear Dates
                  </button>
                )}
              </div>
            </div>

            <div style={{ position: "relative", width: "100%", maxWidth: "300px" }}>
              <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: THEME.mutedForeground, display: "flex", alignItems: "center" }}>
                <Search size={14} />
              </span>
              <input
                type="text"
                placeholder="Search within active tab..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: "100%", padding: "8px 12px 8px 34px", fontSize: "13px", borderRadius: "8px",
                  border: `1px solid ${THEME.border}`, outline: "none", color: THEME.foreground, backgroundColor: "#fafafa"
                }}
              />
            </div>
          </div>

          {/* 1. DESKTOP VIEW STANDARD LAYOUT */}
          <div className="desktop-table-view" style={{ overflowX: "auto", width: "100%" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", fontSize: "13px" }}>
              <thead>
                <tr style={{ borderBottom: `1px solid ${THEME.border}`, backgroundColor: "rgba(241,245,249,0.5)" }}>
                  <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Customer Mobile</th>
                  <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Status</th>
                  <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Date</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((item) => (
                    <tr key={item.id} style={{ borderBottom: `1px solid ${THEME.border}`, transition: "background-color 0.2s" }}>
                      <td style={{ padding: "14px 20px", fontWeight: "500" }}>
                        <span style={{ fontFamily: "monospace", fontSize: "12px", color: THEME.mutedForeground }}>{item.customer_mobile}</span>
                      </td>
                      <td style={{ padding: "14px 20px" }}>
                        <span style={{
                          display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: "500",
                          textTransform: "capitalize", border: "1px solid", ...(STATUS_BADGE[item.status] || STATUS_BADGE.read)
                        }}>
                          {item.status || "Unknown"}
                        </span>
                      </td>
                      <td style={{ padding: "14px 20px", color: THEME.mutedForeground, whiteSpace: "nowrap" }}>
                        {item.received_date ? new Date(item.received_date).toLocaleDateString() : "—"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} style={{ padding: "32px", textAlign: "center", color: THEME.mutedForeground }}>No logs matching selected conditions.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* 2. MOBILE VIEW */}
          <div className="mobile-cards-view">
            {currentItems.length > 0 ? (
              currentItems.map((item) => (
                <div key={item.id} className="mobile-card-row">
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontSize: "12px", fontFamily: "monospace", color: THEME.mutedForeground }}>#{item.id}</span>
                    <span style={{
                      display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: "500",
                      textTransform: "capitalize", border: "1px solid", ...(STATUS_BADGE[item.status] || STATUS_BADGE.read)
                    }}>
                      {item.status || "Unknown"}
                    </span>
                  </div>

                  <div>
                    <div style={{ fontSize: "11px", color: THEME.mutedForeground, textTransform: "uppercase", fontWeight: "600", marginBottom: "2px" }}>Customer Mobile</div>
                    <div style={{ fontSize: "14px", fontWeight: "500" }}>
                      {item.waid ? (
                        <span style={{ color: "#059669", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.waid}</span>
                      ) : (
                        <span style={{ color: "#2563eb", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.customer_mobile}</span>
                      )}
                    </div>
                  </div>

                  <div>
                    <div style={{ fontSize: "11px", color: THEME.mutedForeground, textTransform: "uppercase", fontWeight: "600", marginBottom: "2px" }}>Received Message</div>
                    <div
                      onClick={() => handleMessageClick(item)}
                      style={{ fontSize: "13px", color: '#2563eb', cursor: 'pointer', wordBreak: "break-word" }}
                    >
                      {item.receivedMessage || <span style={{ color: THEME.mutedForeground }}>—</span>}
                    </div>
                  </div>

                  <div>
                    <div style={{ fontSize: "11px", color: THEME.mutedForeground, textTransform: "uppercase", fontWeight: "600", marginBottom: "2px" }}>Received Date</div>
                    <div style={{ fontSize: "13px", color: THEME.foreground }}>
                      {item.received_date ? new Date(item.received_date).toLocaleDateString() : "—"}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div style={{ padding: "32px", textAlign: "center", color: THEME.mutedForeground, fontSize: "13px" }}>
                No logs matching selected conditions.
              </div>
            )}
          </div>

          {/* Table Pagination Actions */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderTop: `1px solid ${THEME.border}`, backgroundColor: "#fafafa" }}>
            <p style={{ fontSize: "12px", color: THEME.mutedForeground, margin: 0 }}>
              Showing {filteredData.length > 0 ? indexOfFirstItem + 1 : 0} to {Math.min(indexOfLastItem, filteredData.length)} of {filteredData.length} entries
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <button
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
                style={{
                  padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: currentPage === 1 ? "#94a3b8" : THEME.foreground,
                  border: `1px solid ${THEME.border}`, backgroundColor: THEME.card, cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                }}
              >
                Previous
              </button>
              <span style={{ fontSize: "12px", fontWeight: "600", padding: "0 8px", color: THEME.foreground }}>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === totalPages}
                style={{
                  padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: currentPage === totalPages ? "#94a3b8" : THEME.foreground,
                  border: `1px solid ${THEME.border}`, backgroundColor: THEME.card, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                }}
              >
                Next
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default MessageAnalytics;